module.exports = __webpack_public_path__ + "teqbahn-assets/media/1.1690fb76.png";